import React from "react";
import "./ContactActions.css";
import ContactCTAButtons from "../ContactCTAButtons/ContactCTAButtons";

type ContactActionsProps = {
  scheduleButtonHref?: string;
  scheduleOpensInNewTab?: boolean;
  children?: React.ReactNode;
};

const ContactActions: React.FC<ContactActionsProps> = ({
  scheduleButtonHref = "/book-appointment",
  scheduleOpensInNewTab = false,
  children,
}) => {
  return (
    <div className="contact-wrap">
      <div className="btn-row">
        <ContactCTAButtons
          scheduleButtonHref={scheduleButtonHref}
          scheduleOpensInNewTab={scheduleOpensInNewTab}
        />
      </div>

      {children}
    </div>
  );
};

export default ContactActions;
